"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "mongrassano": {
    "a9aa9d78": [{
      "hkey": "879d7ee8",
      "slug": "mongrassano",
      "name": "Mongrassano",
      "primary": true,
      "skipSearch": false
    }],
    "cataldo": [{
      "hkey": "879d7ee8",
      "slug": "mongrassano",
      "name": "Mongrassano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7f19030a": [{
      "hkey": "879d7ee8",
      "slug": "mongrassano",
      "name": "Mongrassano",
      "primary": true,
      "skipSearch": false
    }],
    "cocchiato": [{
      "hkey": "879d7ee8",
      "slug": "mongrassano",
      "name": "Mongrassano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3c73315e": [{
      "hkey": "879d7ee8",
      "slug": "mongrassano",
      "name": "Mongrassano",
      "primary": true,
      "skipSearch": false
    }],
    "sbrandello": [{
      "hkey": "879d7ee8",
      "slug": "mongrassano",
      "name": "Mongrassano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "5bea7269": [{
      "hkey": "879d7ee8",
      "slug": "mongrassano",
      "name": "Mongrassano",
      "primary": true,
      "skipSearch": false
    }],
    "valle-della-pietra": [{
      "hkey": "879d7ee8",
      "slug": "mongrassano",
      "name": "Mongrassano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;